"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "invoice",
    path: "/invoices/:id",
    component: "Invoice",
    params: [{
            name: "id",
            prop: "oid",
        },
    ]
});
(0, core_1.addRoute)({
    name: "incomingInvoiceCreate",
    path: "/invoices-in/create",
    component: "Invoice",
    componentProps: [{
            name: "newInvoiceKind",
            value: "incoming",
        },
    ]
});
(0, core_1.addRoute)({
    name: "outgoingInvoiceCreate",
    path: "/invoices-out/create",
    component: "Invoice",
    componentProps: [{
            name: "newInvoiceKind",
            value: "outgoing",
        },
    ]
});
let Invoice = class Invoice extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    registerEntry;
    onRegister_entry(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("registerEntry");
    }
    formId;
    onForm_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("formId");
    }
    newInvoiceKind;
    onNew_invoice_kind(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("newInvoiceKind");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    blankItem;
    async $$load_blankItem() {
        return (this.newInvoiceKind == null && this.register_entry == null) ?
            null :
            this.$fn.fetch('get_invoice_template', {
                parameters: {
                    invoice_kind: this.newInvoiceKind,
                    register_entry: this.registerEntry
                },
                asResource: true
            });
    }
    item;
    async $$load_item() {
        return this.blankItem ||
            this.$fn.fetch('read_invoice', { parameters: { id: this.oid } })
                .then(d => {
                if (d.billing_period == null) {
                    d.billing_period = {
                        start: null,
                        end: null
                    };
                }
                return new this.$fn.Resource(d);
            });
    }
    currencies;
    async $$load_currencies() {
        return this.$app.repo.get('list_currency', { map: true, key: 'code' });
    }
    formContext;
    ux;
    b_7315092382398562_modalBindings;
    b_8564662037462133_class;
    async $$load_b_8564662037462133_class() {
        return {
            "bg-transparent": this.card,
            "shadow-sm": this.card,
        };
    }
    dataMembers = ['blankItem', 'item', 'currencies', 'formContext', 'ux', 'b_7315092382398562_modalBindings', 'b_8564662037462133_class'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                blankItem: null,
                item: null,
                currencies: null,
                formContext: {
                    selectedInvoiceLines: null,
                },
                ux: null,
                b_7315092382398562_modalBindings: {
                    noPrimaryButton: true,
                    closeButtonText: this.$fn.gettext("Close"),
                    size: "full-screen",
                },
                b_8564662037462133_class: null,
            },
        };
    }
    get isNew() {
        if (this.loaded) {
            return !this.item || !this.item.id;
        }
        return null;
    }
    get invoiceTypeName() {
        if (this.loaded) {
            return this.item.invoice_type === "correction" ? this.$fn.pgettext("InvoiceType", "Correction") :
                (this.item.invoice_type === "storno" ? this.$fn.pgettext("InvoiceType", "Storno") :
                    (this.item.invoice_type === "proforma" ? this.$fn.pgettext("InvoiceType", "Pro Forma") : "?"));
        }
        return null;
    }
    get currency() {
        if (this.loaded) {
            return this.currencies[this.item.currency];
        }
        return null;
    }
    get exchangedCurrency() {
        if (this.loaded) {
            return this.currencies[this.item.exchanged_currency];
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.item.id ? this.item.invoice_number : this.$fn.gettext('Create Invoice'),
                icon: this.$config.invoice.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3232_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_navigate_3236_getActionArgs($event) {
        return {
            location: {
                name: "app.invoice",
                params: {
                    id: $event.data.id,
                },
            },
        };
    }
    async evh_8564662037462133_created(event, scope) {
        return await this.actions.evh_8564662037462133_created.executeFromDOM(this, event, scope);
    }
    async evh_8564662037462133_deleted(event, scope) {
        return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
    }
    async evh_8564662037462133_reload(event, scope) {
        return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
    }
    async evh_5534025912102772_reload(event, scope) {
        return await this.actions.evh_5534025912102772_reload.executeFromDOM(this, event, scope);
    }
    async evh_1468474219929533_reload(event, scope) {
        return await this.actions.evh_1468474219929533_reload.executeFromDOM(this, event, scope);
    }
    async evh_1548630417156826_reload(event, scope) {
        return await this.actions.evh_1548630417156826_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3232 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3232_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3231 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3232,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3231],
        });
        const act_2248226175642056_closeModal_3234 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_3233 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_3234,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3233],
        });
        const act_8564662037462133_navigate_3236 = new core_1.actions.NavigateAction({
            actionArgs: this.act_8564662037462133_navigate_3236_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_created_3235 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_navigate_3236,
            event: "created",
            displayName: "navigate",
        });
        const evh_8564662037462133_created = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_created_3235],
        });
        const act_8564662037462133_closeComponent_3238 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_8564662037462133_deleted_3237 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_closeComponent_3238,
            event: "deleted",
            displayName: "closeComponent",
        });
        const evh_8564662037462133_deleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_deleted_3237],
        });
        const act_8564662037462133_reloadComponentData_3240 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8564662037462133_reload_3239 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadComponentData_3240,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_8564662037462133_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_reload_3239],
        });
        const act_5534025912102772_reloadComponentData_3242 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_5534025912102772_reload_3241 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_reloadComponentData_3242,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_5534025912102772_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_reload_3241],
        });
        const act_1468474219929533_reloadComponentData_3244 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_1468474219929533_reload_3243 = new core_1.actions.EventHandlerImpl({
            action: act_1468474219929533_reloadComponentData_3244,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_1468474219929533_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1468474219929533_reload_3243],
        });
        const act_1548630417156826_reloadComponentData_3246 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_1548630417156826_reload_3245 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_reloadComponentData_3246,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_1548630417156826_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_reload_3245],
        });
        return {
            act_7315092382398562_closeModal_3232,
            evh_7315092382398562_close_3231,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_3234,
            evh_2248226175642056_close_3233,
            evh_2248226175642056_close,
            act_8564662037462133_navigate_3236,
            evh_8564662037462133_created_3235,
            evh_8564662037462133_created,
            act_8564662037462133_closeComponent_3238,
            evh_8564662037462133_deleted_3237,
            evh_8564662037462133_deleted,
            act_8564662037462133_reloadComponentData_3240,
            evh_8564662037462133_reload_3239,
            evh_8564662037462133_reload,
            act_5534025912102772_reloadComponentData_3242,
            evh_5534025912102772_reload_3241,
            evh_5534025912102772_reload,
            act_1468474219929533_reloadComponentData_3244,
            evh_1468474219929533_reload_3243,
            evh_1468474219929533_reload,
            act_1548630417156826_reloadComponentData_3246,
            evh_1548630417156826_reload_3245,
            evh_1548630417156826_reload,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], Invoice.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Invoice.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], Invoice.prototype, "registerEntry", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('registerEntry'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Invoice.prototype, "onRegister_entry", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: function () {
            return this.$fn.randomElementId();
        },
    }),
    __metadata("design:type", String)
], Invoice.prototype, "formId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('formId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Invoice.prototype, "onForm_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], Invoice.prototype, "newInvoiceKind", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('newInvoiceKind'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Invoice.prototype, "onNew_invoice_kind", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "full-screen",
    }),
    __metadata("design:type", String)
], Invoice.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Invoice.prototype, "onSize", null);
Invoice = __decorate([
    (0, vue_property_decorator_1.Component)()
], Invoice);
exports.default = Invoice;
vue_property_decorator_1.Vue.component("Invoice", Invoice);
